module.exports = __webpack_public_path__ + "img/ford.d97da4a3.jpeg";